import { ViewDispatch } from "./ViewDispatch";
import { SearchTarget } from "../enums/SearchTarget";
import { CommonFunctions } from "../static/common-functions";
import { DQOIDisplaySettings } from "./DQOIDisplaySettings";

export class DispatchData
{
    constructor(data: DispatchData = null) {
        this.viewDispatch = new ViewDispatch();
        if (data != null) {
            console.log("DispatchData-dnn-a:", data, CommonFunctions.hasValue(data.id), CommonFunctions.hasValue(data.number));
            this.viewDispatch = data.viewDispatch;
            if (!CommonFunctions.hasValue(data.id) && !CommonFunctions.hasValue(data.number)) {
                this.id = data.viewDispatch.dispatchId;
                this.target = SearchTarget.dispatch
                this.targetCode = "1";
                console.log("DispatchData-dnn-b:", this);
            }
            else {
                this.id = data.id;
                this.number = data.number;
                this.target = data.target;
                this.targetCode = CommonFunctions.GetDQOIItemCode(this.target);
            }
            this.isConstruction = data.isConstruction;
            this.dqoiDisplaySettings = data.dqoiDisplaySettings;
        }
    }
    viewDispatch: ViewDispatch;
    id: any;
    number: any;
    target: SearchTarget;
    isConstruction: boolean;
    targetCode: string;
    dqoiDisplaySettings: DQOIDisplaySettings = null;
}
